import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Thermometer03 = function Thermometer03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 3h-6m6 4h-6m6 4h-6m-9.5 2.7578V4.5C5.5 3.1193 6.6193 2 8 2s2.5 1.1193 2.5 2.5v9.2578c1.206.8072 2 2.182 2 3.7422 0 2.4853-2.0147 4.5-4.5 4.5s-4.5-2.0147-4.5-4.5c0-1.5602.794-2.935 2-3.7422M9 17.5c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    })
  }));
};
export default Thermometer03;